// Returns true if currently running in Prod, false otherwise
export const isProd = (): boolean => {
  const env = import.meta.env.VITE_ENV;
  return env?.startsWith('prod') ?? false;
};

// Returns string of the current environment
export const getEnvName = (): string => {
  return import.meta.env.VITE_ENV ?? 'development';
};
